// frontend/src/AppFooter.tsx - Universal Copyright Footer Component

import React from 'react';

const AppFooter: React.FC = () => {
  const styles = {
    footer: {
      background: 'var(--color-surface)',
      borderTop: '1px solid var(--color-surface-variant)',
      padding: 'var(--spacing-sm) var(--spacing-lg)',
      textAlign: 'center' as 'center',
      fontSize: '0.75rem',
      color: 'var(--color-on-surface-variant)',
      marginTop: 'auto', // Push footer to bottom
    }
  };

  return (
    <footer style={styles.footer}>
      © 2025 EvaluTool. All rights reserved.
    </footer>
  );
};

export default AppFooter;